import React, {useEffect, useState} from 'react';
import Moment from 'moment';
import Select from 'react-select'
import { useForm } from "react-hook-form";
import { Button, CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import {
    getFirstDayOfMonth,
    getFirstDayOfYear,
    getLastDayOfMonth, getLastDayOfYear,
    monthSelectOptions,
    yearSelectOptions
} from "../../../util/DateTools";
import SelectGeneric from "../../../components/select/selectGeneric";
import {applicativeProvider} from "../../../providers/applicativeProvider";
import {paramSettingsProvider} from "../../../providers/paramSettingsProvider";
import {udnProvider} from "../../../providers/udnProvider";

export default function AppRequestLogDashboardFilters(props) {
    const date = new Date()
    const [searchBy, setSearchBy] = useState('RANGE'); // YEAR, MONTH, RANGE
    const [yearOption, setYearOption] = useState(null);
    const [monthOption, setMonthOption] = useState(null);
    const [to, setTo] = useState( getLastDayOfMonth(date.getFullYear(), date.getMonth()) );
    const [from, setFrom] = useState( getFirstDayOfMonth(date.getFullYear(), date.getMonth()) );
    const [difWP, setDifWP] = useState(false)
    const [applicative, setApplicative] = useState( null);
    const [udn, setUdn] = useState( null);
    const [os, setOS] = useState( null);
    const [method, setMethod] = useState( null);
    const [resetValues, setResetValues] = useState(false);

    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            to : Moment(to).format('yyyy-MM-DD 23:59'),
            from : Moment(from).format('yyyy-MM-DD 00:00')
        }
    });

    useEffect(() => {
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const itemOption = monthSelectOptions.find( it => it.value === month );

        const fromDate = getFirstDayOfMonth( date.getFullYear(), date.getMonth() );
        const toDate = getLastDayOfMonth( date.getFullYear(), date.getMonth() );

        setMonthOption(itemOption);
        setFrom( fromDate );
        setTo( toDate );
    },[])

    const onYearChange = year => {
        const itemOption = yearSelectOptions.find( it => it.value === year );
        const fromDate = getFirstDayOfYear( year );
        const toDate = getLastDayOfYear( year );

        setYearOption(itemOption);
        setTo( toDate );
        setFrom( fromDate );
    }

    const onMonthChange = month => {
        const itemOption = monthSelectOptions.find( it => it.value === month );
        const selectedMonth = parseInt( month ) - 1;
        const fromDate = getFirstDayOfMonth( date.getFullYear(), selectedMonth );
        const toDate = getLastDayOfMonth( date.getFullYear(), selectedMonth );

        setMonthOption( itemOption );
        setTo( toDate );
        setFrom( fromDate );
    }

    const onSubmit = (data, _) => {
        const _dataFilter = {
            to : Moment(to).format('yyyy-MM-DD 23:59:59'),
            from : Moment(from).format('yyyy-MM-DD 00:00:00')
        };

        if (applicative != null) {
            _dataFilter.applicative = applicative;
        }

        if (os != null) {
            _dataFilter.os = os;
        }

        if (method != null) {
            _dataFilter.method = method;
        }

        props.refreshFiltered(_dataFilter);
    };

    const cleanFields = () => {
        setSearchBy( 'MONTH' );
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        onMonthChange(month);
        setApplicative(null);
        setDifWP(false);
        setResetValues(!resetValues);
        reset();
    }

    const changeSearchType = (_searchBy) => {
        setSearchBy(_searchBy)
        setMonthOption(null);
        setYearOption(null);
        onMonthChange(monthOption.value);
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="4">
                    <Row>
                        <Col md="4">
                            <Button onClick={_ => changeSearchType('YEAR')} >Por año:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="12">
                            <Label>Año</Label>
                            <Select
                                value = { yearOption }
                                options = {yearSelectOptions}
                                isClearable = { true }
                                isDisabled = { !(searchBy === 'YEAR') }
                                onChange = { val => onYearChange(val?.value) }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md="4">
                    <Row>
                        <Col md="4">
                            <Button onClick={_ => changeSearchType('MONTH')} >Por mes:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="12">
                            <Label>Mes</Label>
                            <Select
                                value = { monthOption }
                                options = { monthSelectOptions }
                                isClearable = { true }
                                isDisabled = { !(searchBy === 'MONTH') }
                                onChange = { val => onMonthChange(val?.value) }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md="4">
                    <Row>
                        <Col md="4">
                            <Button onClick={_ => changeSearchType('RANGE')} >Por fecha:</Button>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md="6" >
                            <Label>Desde</Label>
                            <Input type="date"
                                   name="from"
                                   value={from}
                                   disabled={ !(searchBy === 'RANGE') }
                                   onChange={e => setFrom(e.target.value)}
                                   innerRef={register}
                            />
                        </Col>
                        <Col md="6">
                            <Label>Hasta</Label>
                            <Input type="date"
                                   name="to"
                                   value={to}
                                   disabled={ !(searchBy === 'RANGE') }
                                   onChange={e => setTo(e.target.value)}
                                   innerRef={register}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <br />
            <Row>
                <Col md="2">
                    <FormGroup>
                        <Label>Aplicación</Label>
                        <SelectGeneric
                            initialValue={ applicative }
                            setExternalValue = { value => setApplicative( value ) }
                            isDisabled = { false }
                            resetValue={ resetValues }
                            provider = { applicativeProvider }
                        />
                    </FormGroup>
                </Col>
                {/*<Col md="2">*/}
                {/*    <FormGroup>*/}
                {/*        <Label>Unidad de negocio</Label>*/}
                {/*        <SelectGeneric*/}
                {/*            initialValue={ udn }*/}
                {/*            setExternalValue = { value => setUdn( value ) }*/}
                {/*            isDisabled = { false }*/}
                {/*            resetValue={ resetValues }*/}
                {/*            provider = { udnProvider }*/}
                {/*        />*/}
                {/*    </FormGroup>*/}
                {/*</Col>*/}
                <Col md="2">
                    <FormGroup>
                        <SelectGeneric
                            title={ 'Sistema operativo' }
                            initialValue={ os }
                            setExternalValue={ setOS }
                            provider={ paramSettingsProvider }
                            customFilter={{item:{ps_key: 'xkynet_config_os_options'}} }
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <SelectGeneric
                            title={ 'Metodo' }
                            initialValue={ method }
                            setExternalValue={ setMethod }
                            provider={ paramSettingsProvider }
                            customFilter={{item:{ps_key: 'xkynet_config_app_request_log_method_list'}} }
                        />
                    </FormGroup>
                </Col>
                {/*<Col  md="2">*/}
                {/*    <FormGroup>*/}
                {/*        <Label>Segmentar WorldPay</Label>*/}
                {/*        <br/>*/}
                {/*        <Switch*/}
                {/*            animate={true}*/}
                {/*            offText={"No"}*/}
                {/*            onText={"Si"}*/}
                {/*            value={difWP}*/}
                {/*            onChange={() => setDifWP(!difWP)}*/}
                {/*        />*/}
                {/*    </FormGroup>*/}
                {/*</Col>*/}
            </Row>
            <br />
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}